import { z } from 'zod';

// US EIN: 12-3456789
const US_EIN_PATTERN = /^\d{2}-\d{7}$/;
// CRA program account identifiers: corporate income tax, excise duty, excise
// tax, air travel security charge, import/export, insurance premium tax,
// payroll, registered charity, GST/HST, information returns, softwood lumber.
const CRA_PROGRAM_IDENTIFIERS = ['RC', 'RD', 'RE', 'RG', 'RM', 'RN', 'RP', 'RR', 'RT', 'RZ', 'SL'];
// Canadian Business Number, optionally with its program account suffix
// (e.g. 123456789, 123456789RT0001, 123456789 RT 0001).
const CA_BUSINESS_NUMBER_PATTERN = new RegExp(`^\\d{9}([ -]?(${CRA_PROGRAM_IDENTIFIERS.join('|')})[ -]?\\d{4})?$`, 'i');
// Tax number validation schema: accepts a US EIN or a Canadian Business Number
const taxNumberSchema = z
    .string()
    .trim()
    .min(1, 'Tax number is required')
    .refine((value) => US_EIN_PATTERN.test(value) || CA_BUSINESS_NUMBER_PATTERN.test(value), 'Enter a valid EIN (e.g., 12-3456789) or Canadian Business Number (e.g., 123456789RT0001)');
/** A US EIN, accepted as `123456789` or `12-3456789` and output as `12-3456789`. */
const usEinSchema = z
    .string()
    .trim()
    .regex(/^\d{2}-?\d{7}$/, 'Enter the 9-digit EIN, for example 12-3456789')
    .transform((value) => {
    const digits = value.replace('-', '');
    return `${digits.slice(0, 2)}-${digits.slice(2)}`;
});
// Bank account number validation schema
const bankAccountNumberSchema = z
    .string()
    .min(1, 'Bank account number is required')
    .regex(/^\d{10,19}$/, 'Enter a valid bank account number');
// Bank routing number validation schema
const bankRoutingNumberSchema = z
    .string()
    .min(1, 'Bank routing number is required')
    .regex(/^\d{9}$/, 'Enter a valid bank routing number');
/** A buyer's gross annual income in dollars. */
const annualIncomeSchema = z.number().finite().positive('Enter your annual income');

export { annualIncomeSchema, bankAccountNumberSchema, bankRoutingNumberSchema, taxNumberSchema, usEinSchema };
//# sourceMappingURL=financial.js.map
